/**
 * Утилита для проверки действительности паспорта
 */

/**
 * Проверяет, просрочен ли паспорт на основе даты окончания действия
 * @param passportDateEnd - Дата окончания действия паспорта в формате строки
 * @returns true если паспорт просрочен, false если действителен или дата не указана
 */
export const isPassportExpired = (passportDateEnd?: string): boolean => {
  if (!passportDateEnd) return false;
  
  try {
    let expiryDate: Date;
    
    // Пробуем разные форматы даты
    if (passportDateEnd.includes('.')) {
      // Формат DD.MM.YYYY или DD.MM.YY
      const [day, month, year] = passportDateEnd.split('.');
      const fullYear = year.length === 2 ? `20${year}` : year;
      expiryDate = new Date(parseInt(fullYear), parseInt(month) - 1, parseInt(day));
    } else if (passportDateEnd.includes('-')) {
      // Формат YYYY-MM-DD или DD-MM-YYYY
      const parts = passportDateEnd.split('-');
      if (parts[0].length === 4) {
        // YYYY-MM-DD
        expiryDate = new Date(passportDateEnd);
      } else {
        // DD-MM-YYYY
        expiryDate = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
      }
    } else {
      // Пробуем стандартный парсинг
      expiryDate = new Date(passportDateEnd);
    }
    
    // Проверяем валидность даты
    if (isNaN(expiryDate.getTime())) {
      console.warn('Invalid passport expiry date format:', passportDateEnd);
      return false;
    }
    
    // Устанавливаем время на конец дня для корректного сравнения
    expiryDate.setHours(23, 59, 59, 999);
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    return expiryDate < today;
  } catch (error) {
    console.error('Error parsing passport expiry date:', error, passportDateEnd);
    return false;
  }
};

